module.exports = __webpack_public_path__ + "img/name.e4db4810.svg";